import moment from 'moment';
import { getAncillariesSelected, getDtd, getFareType, passengerCount, SEAT_CHOICES, sortAlphabetically } from '../../../../utilities/helpers';
import { capitalize } from 'lodash';
import { sendAncillaryEventToCustomerIO } from '../../../../utilities/customer-io-ancillary-events';

export default (products, pnrModel, userProfile, isActiveFlowCorporate, userCorporate) => {
  const pnrInfo = pnrModel;
  const product = products;

  const items = [];
  let tripType = 'MC';
  const segments = [];
  let zone = 'NA';
  const legCollection = pnrInfo?.legCollection;
  const outboundSegments = legCollection?.[0]?.segmentsCollection;
  const inboundSegments = legCollection?.[legCollection?.length - 1]?.segmentsCollection;
  let stopNumbers = 0;
  if (pnrInfo?.flightItineraryType === 'ONEWAY') {
    tripType = 'OW';
  } else if (pnrInfo?.flightItineraryType === 'ROUNDTRIP') {
    tripType = 'RT';
  }

  if (legCollection?.length > 0) {
    legCollection.forEach((element) => {
      const data = element?.segmentsCollection;
      stopNumbers = data?.length > 1 ? stopNumbers + (data?.length - 1) : stopNumbers;
      data.map((segmentsData) => {
        segments.push(segmentsData);
      });
    });
  }

  const apiDepartureDate = moment(segments?.[0]?.departureDateTime);
  const transactionDate = moment(pnrInfo?.creationDate);
  const apiItem = apiDepartureDate.diff(transactionDate, 'days');
  const dtd = getDtd(segments?.[0]?.departureDateTime);

  const inboundDepartureDate = pnrInfo?.flightItineraryType === 'ROUNDTRIP' ? inboundSegments?.[0]?.departureDateTime?.format('YYYYMMDD') : 'NA';
  const inboundArrivalDate = pnrInfo?.flightItineraryType === 'ROUNDTRIP' ? inboundSegments?.[inboundSegments?.length - 1]?.arrivalDateTime?.format('YYYYMMDD') : 'NA';

  const arrivalAirport = outboundSegments?.[outboundSegments?.length - 1]?.arrivalAirport || 'NA';
  const departureAirport = outboundSegments?.[0]?.departureAirport || 'NA';
  const marketOd = `${departureAirport}${arrivalAirport}`;
  let marketNdod = `${arrivalAirport}${departureAirport}` || 'NA';

  if (departureAirport < arrivalAirport) {
    marketNdod = `${departureAirport}${arrivalAirport}` || 'NA';
  }

  const outboundDepartureDate = outboundSegments?.[0]?.departureDateTime?.format('YYYYMMDD') || 'NA';
  const outboundArrivalDate = outboundSegments?.[outboundSegments?.length - 1]?.arrivalDateTime?.format('YYYYMMDD');

  const marketCarrier = (legCollection || []).map((legData) => {
    const segmentCollection = legData?.segmentsCollection || [];
    const segments = segmentCollection.map(segment => {
      return `${segment?.marketingCarrier}`;
    }).join('/');
    return segments;
  }).join('-');

  let apItemRange = '';
  switch (true) {
    case (apiItem >= 0 && apiItem <= 2):
      apItemRange = '0 a 2';
      break;
    case (apiItem >= 3 && apiItem <= 6):
      apItemRange = '3 a 6';
      break;
    case (apiItem >= 7 && apiItem <= 13):
      apItemRange = '7 a 13';
      break;
    case (apiItem >= 14 && apiItem <= 20):
      apItemRange = '14 a 20';
      break;
    case (apiItem >= 21 && apiItem <= 27):
      apItemRange = '21 a 27';
      break;
    case (apiItem >= 28 && apiItem <= 49):
      apItemRange = '28 a 49';
      break;
    case (apiItem >= 50 && apiItem <= 89):
      apItemRange = '50 a 89';
      break;
    case (apiItem >= 90 && apiItem <= 119):
      apItemRange = '90 a 119';
      break;
    case (apiItem >= 120 && apiItem <= 149):
      apItemRange = '120 a 149';
      break;
    case (apiItem >= 150):
      apItemRange = '150+';
      break;
    default:
      apItemRange = 'NA';
      break;
  }

  let msItem = 0;
  if (segments?.length > 1) {
    const firstSegment = moment(segments?.[0]?.departureDateTime);
    const lastSegment = moment(segments?.[segments.length - 1]?.arrivalDateTime);
    msItem = tripType !== 'MC' ? lastSegment.diff(firstSegment, 'days') : 0;
  }

  const marketSegments = legCollection.map((legData) => {
    const segmentCollection = legData?.segmentsCollection || [];
    const segments = segmentCollection.map(segment => {
      return `${segment?.departureAirport || 'NA'}${segment?.arrivalAirport || 'NA'}`;
    }).join('/');
    return segments;
  }).join('-');

  const bookingClassTest = [];
  const cabinClassTest = [];
  (legCollection || []).forEach((element) => {
    const segmentsInfo = element?.segmentsCollection;
    const bookingClass = [];
    const cabinClass = [];
    (segmentsInfo || []).forEach((segmentsData) => {
      bookingClass.push(segmentsData?.bookingClass || 'NA');
      cabinClass.push(segmentsData?.cabin || 'NA');
    });
    bookingClassTest.push(bookingClass.join('/'));
    cabinClassTest.push(cabinClass.join('/'));
  });
  const bookingClassSegment = bookingClassTest.join('-');
  const cabinClassSegment = cabinClassTest.join('-');

  const travelerCollection = pnrInfo?.cart?.travelerCollection || [];

  const ffNumber = `${userProfile?.ffNumber}`;
  let ffProgram = 'NA';
  travelerCollection.forEach(passenger => {
    if (passenger?.frequentFlyerNumber === ffNumber) {
      ffProgram = passenger?.frequentFlyerProgram;
    }
  });

  const travelerCount = passengerCount(travelerCollection);
  const [ancillariesSelected] = getAncillariesSelected(travelerCollection, products);
  const corpProgram = isActiveFlowCorporate ? 'AM Rewards Business' : 'NA';
  let corpId = 'NA';
  const companySelected = userCorporate?.companySelected;
  (userCorporate?.companies?.companies || []).forEach(company => {
    corpId = company?.companyName === companySelected ? company?.companyLoyaltyNumber : corpId;
  });

  if (pnrInfo?.globalMarketFlight === 'DOMESTIC') {
    zone = 'DOM';
  } else if (pnrInfo?.globalMarketFlight === 'INTERNATIONAL' || pnrInfo?.globalMarketFlight === 'TRANSBORDER') {
    zone = 'INT';
  }

  const itemBrand = 'AM';
  let itemCategory = 'Ancillary';
  let itemAffiliation = 'NA';
  let itemCategory2 = 'NA';
  let itemCategory3 = 'NA';
  let itemListName = 'NA';
  let itemName = 'NA';
  let pricePoints = 0;
  const route = product?.route;
  let value = 0;
  let params = [];
  (legCollection || []).forEach((legs, index) => {
    (legs?.segmentsCollection || []).forEach((passenger, segmentIndex) => {
      const productId = product?.ancillary?.item?.id || product?.id;
      let price = 0;
      let quantity = 0;
      const sourceDestination = `${passenger?.departureAirport}_${passenger?.arrivalAirport}`;
      itemListName = tripType ? (tripType === 'OW' || tripType === 'MC') ? 'ancillaries outbound' : legs?.itineraryPartType === 'OUTBOUND' ? 'ancillaries outbound' : 'ancillaries inbound' : 'NA';
      const seatCategory = SEAT_CHOICES[product?.section] || capitalize(product?.section); 
      switch (productId) {
        case '09T':
          itemCategory = 'Services';
          travelerCollection.forEach((passengers) => {
            const passengerData = passengers?.ancillaries?.ancillaries;
            passengerData.forEach((ancillaries) => {
              if (!ancillaries?.isPaid && ancillaries?.ancillary?.commercialName === 'AEROMEXICO VUELA VERDE' && legs?.legType === 'CONNECTING' ? ancillaries?.segmentCode?.includes(sourceDestination) : legs?.legType !== 'CONNECTING') {
                price = ancillaries?.ancillary?.currencyPerSegmentArray?.find((currencySegment) =>  currencySegment?.segmentCode?.includes(sourceDestination))?.currency?.total;
              }
            });
          });
          itemCategory2 = 'Fly Green';
          itemCategory3 = 'NA';
          itemAffiliation = 'AM';
          if (price !== undefined) {
            value += price * travelerCollection?.length;
          }
          quantity = price > 0 ? travelerCollection?.length : 0;
          break;
        case 'CBX':
          travelerCollection.forEach((passengers) => {
            const passengerData = passengers?.ancillaries?.ancillaries;
            passengerData.forEach((ancillaries) => {
              if (!ancillaries?.isPaid && ancillaries?.ancillary?.commercialName === 'CBX CROSS BORDER XPRESS' && legs?.legType === 'CONNECTING' ? ancillaries?.segmentCode?.includes(sourceDestination) : legs?.legType !== 'CONNECTING') {
                price = ancillaries?.ancillary?.currencyPerLegArray?.[index]?.currency?.total;
              }
            });
          });
          itemCategory2 = 'CBX';
          itemCategory3 = 'NA';
          itemAffiliation = 'AM';
          if (price !== undefined) {
            value += price * travelerCollection?.length;
          }
          quantity = travelerCollection?.length;
          break;
        default:
          itemCategory2 = 'Seat';
          itemCategory3 = seatCategory  + '|' + product?.seat;
          itemAffiliation = 'AM';
          price = product?.price;
          pricePoints = product?.pricepoints;
          quantity = product?.quantity;
          break;
      }

      itemCategory2 = itemCategory2.trim();
      itemCategory3 = itemCategory3.trim();

      const departureDateTime = moment(passenger?.departureDateTime).format('YYYYMMDD HH:mm:ss');
      const departureTime = moment.utc(passenger?.flightDurationInMinutes * 60000).format('HH:mm');
      let marketOdItem = `${passenger?.departureAirport}${passenger?.arrivalAirport}`;
      itemName = marketOdItem || 'NA';
      const segment = passenger?.departureAirport + '-' + passenger?.arrivalAirport;
      const opCarrier = passenger?.operatingCarrier;
      const seatCheck = productId === '09T' || productId === 'CBX' ? true : route === segment;
      const brandedFare = getFareType(passenger);
      if (productId === 'CBX' && segmentIndex !== 0) return;
      let marketSegmentsItem = marketOdItem || 'NA';
      if (productId === 'CBX') {
        itemName = `${legs?.segmentsCollection?.[0]?.departureAirport}${legs?.segmentsCollection?.[legs?.segmentsCollection.length - 1]?.arrivalAirport}`;
        marketOdItem = itemName;
        marketSegmentsItem = (legs?.segmentsCollection || []).map((segment) => {
          return `${segment?.departureAirport || 'NA'}${segment?.arrivalAirport || 'NA'}`;
        }).join('/');
      }

      const marketNdodItem = itemCategory2 === 'Seat' ? sortAlphabetically(marketOdItem?.substring(3, 6), marketOdItem?.substring(0, 3)) :  marketNdod;

      if (seatCheck) {
        params = {
          'item_name': itemName,
          'coupon': 'NA',
          'discount': 0,
          'item_brand': itemBrand,
          'item_category': itemCategory,
          'item_category2': itemCategory2,
          'item_category3': itemCategory3,
          'item_list_name': itemListName,
          'item_affiliation': itemAffiliation,
          'price': price || 0,
          'quantity': quantity || 0,
          'index': index,
          'market_ndod_item': marketNdodItem || 'NA',
          'market_od_item': marketOdItem || 'NA',
          'market_segment_item': marketSegmentsItem,
          'zone_item': passenger?.marketFlightFromLeg === 'DOMESTIC' ? 'DOM' : 'INT' || 'NA',
          'region_item': passenger?.regionKeyFromLeg || 'NA',
          'flight_time_dep': departureDateTime || 'NA',
          'flight_time': departureTime || 'NA',
          'branded_fare': brandedFare,
          'outbound_departure_date_item': outboundDepartureDate || 'NA',
          'inbound_departure_date_item': inboundDepartureDate,
          'fop_type_item': 'Cash',
          'price_points': pricePoints || 0,
          'airport_tax': pnrInfo?.cart?.total?.taxDetails?.TUA || 0,
          'aircraft_type': passenger?.aircraftType || 'NA',
          'aircraft_subfleet': `${opCarrier}${passenger?.aircraftType}` || 'NA',
          'ap_item': apItemRange,
          'ms_item': msItem,
          'cabin_item': passenger?.cabin || 'NA',
          'op_carrier': opCarrier || 'NA',
          'class_item': passenger?.bookingClass || 'NA',
        };
        items.push(params);
      }
    });
  });

  let fopType = 'Cash';
  value = 0;
  value = ancillariesSelected?.reduce((acc, product) => {
    return !product?.redeemedCP ? acc + (product?.price * product?.quantity) : acc;
  }, 0);
  const totalPoints = ancillariesSelected?.reduce((acc, product) => {
    return product?.redeemedCP ? acc + (product?.pricepoints * product?.quantity) : acc;
  }, 0);
    
  if (totalPoints > 0 && value > 0) {
    fopType = 'Cash+Points';
  } else if (totalPoints > 0 && value === 0) {
    fopType = 'Points';
  } else {
    fopType = 'Cash';
  }

  const result = {
    event: 'view_item',
    ecommerce: {
      'currency': product?.currencyCode || pnrInfo?.cart?.total?.currencyCode || 'NA',
      'value': value || 0,
      'funnel_name': 'MYB',
      'sub_funnel_name': 'Ancillary',
      'trip_type': tripType,
      'fop_type': fopType,
      'outbound_departure_date': outboundDepartureDate || 'NA',
      'inbound_departure_date': inboundDepartureDate,
      'outbound_arrival_date': outboundArrivalDate || 'NA',
      'inbound_arrival_date': inboundArrivalDate,
      'zone': zone,
      'market_od': marketOd || 'NA',
      'market_ndod': marketNdod || 'NA',
      'market_segment': marketSegments,
      'mkt_carrier': marketCarrier,
      'region': legCollection?.[0]?.regionKey || 'NA',
      'value_points': totalPoints,
      'ffn_program': ffProgram,
      'ffn_id': ffNumber === 'undefined' ? 'NA' : ffNumber,
      'corp_program': corpProgram,
      'corp_id': corpId,
      'adults': travelerCount?.adults,
      'childs': travelerCount?.child,
      'infants': travelerCount?.infants,
      'adult_minor': travelerCount?.adultMinors,
      'stops_number': stopNumbers,
      'dtd': dtd,
      'clid_benefits': 'NA',
      'cabin': cabinClassSegment || 'NA',
      'class': bookingClassSegment || 'NA',
      'items': items,
    },
  };

  try {
    sendAncillaryEventToCustomerIO('seatselection', result, pnrInfo);
  } catch (error) {
    // Silent error
  }

  return result;
};
